<script lang="ts" setup>
import { useDialogStore } from "./store/dialog";
import FadeTransition from "./components/transition/FadeTransition.vue";
import { useLoadingStore } from "./store/loading";
import mixpanel from 'mixpanel-browser';
import { render } from "vue";

const dialogStore = useDialogStore();
const dialog = ref(null);

const { detectedLocale } = useLanguageManager();
detectedLocale();

const loadingStore = useLoadingStore();

const { appContext } = getCurrentInstance();

watch([dialogStore.dialogInfoList], (next, prev: any[]) => {
    render(null, dialog.value);
    for (let item of dialogStore.dialogInfoList)
        if (item.vNode) {
            item.vNode.appContext = appContext;
            render(item.vNode, dialog.value);
        }
});

if (window.location.host === 'webview.plkey.app') {
  mixpanel.init("70b9a9bcbb0361b4a43f97f17a01994f");
} else {
  mixpanel.init("TEST_TOKEN");
}

</script>

<template>
    <div class="app" id="app" ref="scrollBody">
        <NuxtPage> </NuxtPage>
    </div>
    <ClientOnly>
        <FadeTransition>
            <TheLoading v-if="loadingStore.isLoading"></TheLoading>
        </FadeTransition>
        <div id="dialog" ref="dialog"></div>
        <div id="bottom-sheet"></div>
        <div id="floating"></div>
    </ClientOnly>
</template>

<style lang="scss">
.app {
    overflow-x: hidden;
    position: relative;

    width: 100%;
    max-width: 640px;

    margin: 0 auto;

    background-color: white;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
}
</style>
